module.exports = __webpack_public_path__ + "img/css.6c6fdbe9.svg";